import { User } from 'firebase/auth';

const KATE_UID = '6230f8ee8576b90386ef2b14'; // Kate's UID, used to overwrite claimed cases

export const isSuperAdmin = (user?: User | null) =>
  user && (user.uid === KATE_UID || user.email === 'jtberglund@gmail.com');
